'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOVER_HOTELS = exports.CLEAR_HOTELS = exports.FETCH_HOTELS_ERROR = exports.FETCH_HOTELS_SUCCESS = exports.FETCH_HOTELS_BEGIN = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.fetchBegin = fetchBegin;
exports.set = set;
exports.clear = clear;
exports.setErrors = setErrors;
exports.hover = hover;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_HOTELS_BEGIN = exports.FETCH_HOTELS_BEGIN = 'FETCH_HOTELS_BEGIN';
var FETCH_HOTELS_SUCCESS = exports.FETCH_HOTELS_SUCCESS = 'FETCH_HOTELS_SUCCESS';
var FETCH_HOTELS_ERROR = exports.FETCH_HOTELS_ERROR = 'FETCH_HOTELS_ERROR';
var CLEAR_HOTELS = exports.CLEAR_HOTELS = 'CLEAR_HOTELS';
var HOVER_HOTELS = exports.HOVER_HOTELS = 'HOVER_HOTELS';

var initialState = {
  isLoading: false,
  items: [],
  errors: [],
  hoverId: '-1'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case FETCH_HOTELS_BEGIN:
      return (0, _extends3.default)({}, state, { isLoading: true });
    case FETCH_HOTELS_SUCCESS:
      return (0, _extends3.default)({}, initialState, action.hotels);
    case CLEAR_HOTELS:
      return (0, _extends3.default)({}, initialState);
    case FETCH_HOTELS_ERROR:
      return (0, _extends3.default)({}, state, { errors: action.errors });
    case HOVER_HOTELS:
      return (0, _extends3.default)({}, state, { hoverId: action.hoverId });
    default:
      return state;
  }
}

// TODO: move the fetching logic to here
// export function fetchHotels() {}

function fetchBegin() {
  return {
    type: FETCH_HOTELS_BEGIN
  };
}

function set(hotels) {
  return {
    type: FETCH_HOTELS_SUCCESS,
    hotels: hotels
  };
}

function clear() {
  return {
    type: CLEAR_HOTELS
  };
}

function setErrors(errors) {
  return {
    type: FETCH_HOTELS_ERROR,
    errors: errors
  };
}
// null, undefine or '' will not trigger a props update
function hover() {
  var hoverId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-1';

  return {
    type: HOVER_HOTELS,
    hoverId: hoverId
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/hotels.js
// module id = 147
// module chunks = 0